/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNav_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_user" | "AccountNavTrigger_user" | "TradeAccountNavContent_user">;
    readonly " $refType": "AccountNav_user";
};
export type AccountNav_user$data = AccountNav_user;
export type AccountNav_user$key = {
    readonly " $data"?: AccountNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNav_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "condition": "hasTradeUserId",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AccountNavContent_user"
            }
          ]
        }
      ]
    },
    {
      "kind": "Defer",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AccountNavTrigger_user"
        }
      ]
    },
    {
      "condition": "hasTradeUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TradeAccountNavContent_user"
            }
          ]
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '6354207af5acec55e238513ad8e4beab';
export default node;
